<template>
  <div>
    <div v-if="cycles.length > 0">
      <div v-for="cycle in cycles" class="parent parent-2" :key="cycle.FSerial">
        <v-card @click="showRegister(cycle)">
          <v-card-title class="info-title">
            <div class="text-center">
              نظر سنجی شماره {{ cycle.FSerial }}-{{ cycle.Title }}
            </div>
          </v-card-title>
        </v-card>
      </div>
    </div>
    <div v-else style="margin: 20px">
      {{ tableText }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["cycles", "tableText"],
  methods: {
    /**
     * user click on register
     */
    showRegister(cycle) {
      this.$emit("nextStep", cycle);
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
</style>


